import { useSmsCampaignsSummaryData } from 'infrastructure/hooks/sms-campaigns';
import BaseLoader from 'components/atoms/base-loader';

import s from './styles.module.scss';
import Card from './card';

import type { ISmsResponsesFilters } from 'infrastructure/interfaces';
import type { FC } from 'react';

interface SmsCampaignSummaryProps {
  filters: ISmsResponsesFilters;
  campaignGuid: string;
}

const SmsCampaignSummary: FC<SmsCampaignSummaryProps> = ({
  filters,
  campaignGuid,
}) => {
  const { data, isLoading } = useSmsCampaignsSummaryData({
    ...filters,
    campaignGuid,
  });

  return (
    <BaseLoader loading={isLoading}>
      <div className={s.summary}>
        {data.data.map((item, index) => (
          <Card key={index} data={item} />
        ))}
      </div>
    </BaseLoader>
  );
};
export default SmsCampaignSummary;
